import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import { Link } from "gatsby"
import styles from "../styles/components/landing.module.scss"

const Landing = ({ sources }) => (
  <section className={styles.hero} id="home" style={{ marginTop: 0 }}>
    <div className={styles.image}>
      <Img fluid={sources} alt="" objectPosition="65% 18%" loading="eager" />
    </div>
    <div className={styles.content}>
      <p className={styles.eyebrow}>Focus. Gain. Attain.</p>
      <h1 className={styles.title}>
        Your <span>Best Body</span>
      </h1>
      <p className={styles.description}>
        Getting in shape isn't hard when you're in a supportive environment.
        Lifetime Fitness is more than just a gym — it's a caring family that's
        there to help you achieve your goals.
      </p>
      <div className={styles.actions}>
        <a href="#contact" className={styles.primary}>
          Get in shape today
        </a>
        <Link to="/blog/" className={styles.secondary}>
          View our blog
        </Link>
      </div>
      <ul className={styles.highlights}>
        <li>Open late</li>
        <li>Professional instructors</li>
        <li>Personalized training</li>
      </ul>
    </div>
  </section>
)
export default Landing
